/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect, useRef } from "react";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { useI18n } from "intl/useI18n";
import StickersTabs from "./Stickers/StickersTabs.vue";
import StickersToolsBorder from "./Stickers/StickersTools/StickersToolsBorder.vue";
import StickersToolsBackground from "./Stickers/StickersTools/StickersToolsBackground.vue";
import ArtworkEnhancementFeedback from "components/jiffy/react-dtf-shared/ArtworkEnhancementFeedback.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import ArtworkImage from "./ArtworkImage.vue";
import DesignServicePromo from "./DesignServicePromo.vue";
import ArtworkQualityConfigPanel from "./ArtworkQualityConfigPanel.vue";
import ArtworkQualityConfigPanelAbAiMonetization from "./ArtworkQualityConfigPanel/ArtworkQualityConfigPanel.vue";
import ArtworkDimensions from "./ArtworkDimensions.vue";
import ArtworkMultiDimensions from "./ArtworkMultiSize/ArtworkMultiDimensions.vue";
import ArtworkQuantity from "./ArtworkQuantity.vue";
import ArtworkInfo from "./ArtworkInfo.vue";
import TrimInfo from "./TrimInfo.vue";
import ArtworkError from "./ArtworkError.vue";
import ArtworkNotification from "./ArtworkNotification.vue";
import ReuploadBox from "./ReuploadBox.vue";
import RedrawNotes, { type RedrawNotesHandle } from "./RedrawNotes.vue";
import MultiSizeTotal from "./ArtworkMultiSize/MultiSizeTotal.vue";
import { useDtfStore } from "./store";
import { cn } from "tailwind-variants";
import "./Artwork.scss";

const TABS = [
  {
    label: "Background",
    icon: "tools-background",
    value: "background"
  },
  {
    label: "Border",
    icon: "tools-border",
    value: "border"
  }
];

export default function Artwork({
  artwork = null,
  index,
  currentStore = null,
  isMultiUpload = false,
  showFullScreenButton = false,
  defaultActiveConfigSection = "jiffy-print-perfect",
  showFreeTransfersBadge = false,
  ...restProps
}: any) {
  const { t } = useI18n();
  const dtfStore = useDtfStore();

  // @ts-expect-error TS(6133): 'width' is declared but its value is never read.
  const [width, setWidth] = useState(null);
  // @ts-expect-error TS(6133): 'height' is declared but its value is never read.
  const [height, setHeight] = useState(null);
  // @ts-expect-error TS(6133): 'quantity' is declared but its value is never read... Remove this comment to see the full error message
  const [quantity, setQuantity] = useState(null);
  const [activeConfigSection, setActiveConfigSection] = useState(defaultActiveConfigSection);

  const rootRef = useRef(null);
  const fileRef = useRef(null);
  const redrawNotesRef = useRef<RedrawNotesHandle>(null);

  const sizeMessageMaxSize = 10;

  function printAsIs() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.printAsIs;
  }

  function pdpType() {
    // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
    return dtfStore.pdpType;
  }

  function sizeErrorTypes() {
    // @ts-expect-error TS(4111): Property 'sizeErrorTypes' comes from an index sign... Remove this comment to see the full error message
    return dtfStore.sizeErrorTypes;
  }

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return dtfStore.sticker;
  }

  function minStickerQuantity() {
    // @ts-expect-error TS(4111): Property 'minStickerQuantity' comes from an index ... Remove this comment to see the full error message
    return dtfStore.minStickerQuantity;
  }

  function isPuff() {
    // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
    return dtfStore.isPuff;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.isSpangle;
  }

  function isSticker() {
    // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.isSticker;
  }

  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.experiments;
  }

  function showRedrawUI() {
    // @ts-expect-error TS(4111): Property 'showRedrawUI' comes from an index signat... Remove this comment to see the full error message
    return dtfStore.showRedrawUI;
  }

  function showMultiSize() {
    // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
    return dtfStore.showMultiSize;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return dtfStore.isStandardArtwork;
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return dtfStore.enableAbAiMonetization;
  }

  function reorderEnabled() {
    // @ts-expect-error TS(4111): Property 'reorderEnabled' comes from an index sign... Remove this comment to see the full error message
    return dtfStore.reorderEnabled;
  }

  function paidExpertEditAddonEnabled() {
    // @ts-expect-error TS(4111): Property 'paidExpertEditAddonEnabled' comes from a... Remove this comment to see the full error message
    return dtfStore.paidExpertEditAddonEnabled;
  }

  function lastConfirmedConfigSection() {
    // @ts-expect-error TS(4111): Property 'lastConfirmedConfigSection' comes from a... Remove this comment to see the full error message
    return dtfStore.lastConfirmedConfigSection;
  }

  function metadata() {
    return artwork?.metadata;
  }

  function withError() {
    return (
      metadata()?.errors?.length > 0 ||
      artwork?.errorMessage ||
      artwork?.uploadError ||
      artwork?.retryFailed
    );
  }

  function isMultiSizeError() {
    return artwork?.isMultiSizeError;
  }

  function hasArtwork() {
    return artwork && !artwork.isSimulated && !artwork.uploadError;
  }

  function hasErrorMessage() {
    const baseCondition = artwork && !artwork.isSimulated;
    return baseCondition && withError() && !isMultiSizeError();
  }

  function isMinQuantityInvalid() {
    return (
      (sticker() || isPuff() || isSpangle()) &&
      artwork?.quantity &&
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artwork?.quantity < minStickerQuantity()
    );
  }

  function isGenericErrorVisible() {
    return withError() || isMinQuantityInvalid();
  }

  function headerIcon() {
    return isGenericErrorVisible() ? "strong-info" : "check-circle-bold";
  }

  // @ts-expect-error TS(6133): 'uploadTimeMessage' is declared but its value is n... Remove this comment to see the full error message
  function uploadTimeMessage() {
    return isSpangle()
      ? `Creating your spangle design! Please allow <b>up to ${t(
          "minute",
          remainingTime()
        )}</b> to get your spangle design.`
      : `Proofing your image and making it print-ready. Please allow <b>up to ${t(
          "minute",
          remainingTime()
        )}</b> to get your print-ready image.`;
  }

  function warningMessage() {
    return artwork?.metadata?.warnings?.human;
  }

  // @ts-expect-error TS(6133): 'reuploadTitle' is declared but its value is never... Remove this comment to see the full error message
  function reuploadTitle() {
    return printAsIs() ? "Re-upload a gang sheet in the correct size" : "Re-upload valid artwork";
  }

  // @ts-expect-error TS(6133): 'reuploadButton' is declared but its value is neve... Remove this comment to see the full error message
  function reuploadButton() {
    return printAsIs() ? "Re-upload a gang sheet" : "Choose file";
  }

  function showReuploadBox() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return !sizeErrorTypes().includes(artwork.errorType?.toString()) && withError();
  }

  function fileSize() {
    return Math.floor((artwork?.file?.size || 0) * 0.000001 || 0);
  }

  function remainingTime() {
    const spangleTime = isSpangle() ? 1 : 0;
    if (Math.ceil(fileSize() / 10) < 1) {
      return 1 + spangleTime;
    }
    return Math.min(Math.ceil(fileSize() / 10), sizeMessageMaxSize) + spangleTime;
  }

  // @ts-expect-error TS(6133): 'showUploadTimeMessage' is declared but its value ... Remove this comment to see the full error message
  function showUploadTimeMessage() {
    return artwork.isLoading;
  }

  function isArtworkUploaded() {
    const artworkId = parseInt(artwork?.id, 10);
    if (Number.isNaN(artworkId)) {
      return false;
    }
    return typeof artworkId === "number" && !artwork?.isLoading;
  }

  function disableCustomSizeInput() {
    return isStandardArtwork() && !artwork?.enhancementCompleted;
  }

  function showRedrawNote() {
    return !isStandardArtwork() && showRedrawUI();
  }

  function displayEnhancementFeedback() {
    return (
      enableAbAiMonetization() &&
      artwork.id &&
      artwork.enhancementCompleted &&
      artwork.enhancementTier === "full_enhancements"
    );
  }

  useEffect(() => {
    const val = lastConfirmedConfigSection();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (val && String(val.artworkId) === String(artwork?.id)) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      setActiveConfigSection(val.section);
    }
  }, [artwork?.id]);

  function addFilesToQueue(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.addFilesToQueue(...args);
  }

  function updateArtworkValuesById(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateArtworkValuesById(...args);
  }

  function getArtworksPricing(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.getArtworksPricing(...args);
  }

  function handleDesignServiceClick() {
    if (!artwork.hasExpertEditAddon) {
      updateArtworkValuesById({
        id: artwork.id,
        hasExpertEditAddon: true,
        enhancementNote: ""
      });
      getArtworksPricing();
    }
    queueMicrotask(() => {
      // @ts-expect-error TS(2339): Property 'querySelector' does not exist on type 'n... Remove this comment to see the full error message
      const customNotesTextarea = rootRef.current?.querySelector(".js-custom-notes-textarea");
      if (customNotesTextarea) {
        customNotesTextarea.focus();
        customNotesTextarea.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      } else if (redrawNotesRef.current) {
        redrawNotesRef.current.focusTextarea();
      }
    });
  }

  // @ts-expect-error TS(7031): Binding element 'h' implicitly has an 'any' type.
  function onDimensionsChange({ height: h, width: w }) {
    setHeight(h);
    setWidth(w);
  }

  // eslint-disable-next-line no-shadow
  function onQtyChange(quantity: any) {
    // eslint-disable-line no-shadow
    setQuantity(quantity);
  }

  function trackAddFileAreaClick() {
    submitDtfEvent("replace_artwork_file_clicked", {
      page: "pdp",
      pdp_type: pdpType()
    });
  }

  // @ts-expect-error TS(6133): 'uploadClick' is declared but its value is never r... Remove this comment to see the full error message
  function uploadClick() {
    trackAddFileAreaClick();
    // @ts-expect-error TS(2339): Property 'click' does not exist on type 'never'.
    fileRef.current?.click();
  }

  function handleFileChange(event: any) {
    const { files } = event.target;
    if (!files.length) return;
    addFilesToQueue({
      files,
      isDropEvent: false,
      artworkIndex: index
    });
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    fileRef.current.value = "";
  }

  function handleSetActiveConfigSection(section: any) {
    setActiveConfigSection(section);
  }

  return (
    <div
      ref={rootRef}
      {...restProps}
      className={cn(
        "artwork scope-f5593a09",
        isGenericErrorVisible() && "artwork--with-error",
        restProps?.className
      )}
    >
      {/* @ts-expect-error TS migration */}
      <input ref={fileRef} type="file" style={{ display: "none" }} onChange={handleFileChange} />
      {artwork ? (
        <div
          className={cn(
            "artwork__header scope-f5593a09",
            isGenericErrorVisible() && "artwork__header--with-error"
          )}
        >
          <div className="artwork__header-icon-wrapper scope-f5593a09">
            {!!metadata() || isGenericErrorVisible() ? (
              <UseSvg
                className="artwork__header-icon scope-f5593a09"
                icon={headerIcon()}
                data-testid="artwork-header-icon"
              />
            ) : null}
          </div>
          <span className="artwork__header-text scope-f5593a09">{artwork.name}</span>
        </div>
      ) : null}
      <div className="artwork__content scope-f5593a09">
        <ArtworkInfo
          className="artwork__sizes scope-f5593a09"
          isMultiUpload={isMultiUpload}
          artwork={artwork}
          index={index}
          data-testid="artwork-sizes"
        />

        <div className="scope-f5593a09">
          <ArtworkImage
            className="artwork__image scope-f5593a09"
            index={index}
            artwork={artwork}
            isMultiUpload={isMultiUpload}
            activeConfigSection={activeConfigSection}
            showFullScreenButton={showFullScreenButton}
            data-testid="artwork-image"
          />

          {isStandardArtwork() && !hasErrorMessage() && hasArtwork() ? (
            <div className="artwork__quality-config scope-f5593a09">
              {displayEnhancementFeedback() && paidExpertEditAddonEnabled() && !isMultiUpload ? (
                <DesignServicePromo
                  className="scope-f5593a09"
                  onDesignServiceClicked={handleDesignServiceClick}
                  data-testid="design-service-promo"
                />
              ) : null}
              {displayEnhancementFeedback() && !isMultiUpload ? (
                <ArtworkEnhancementFeedback
                  className="scope-f5593a09"
                  artwork={artwork}
                  pageType={pdpType()}
                  data-testid="artwork-enhancement-feedback"
                />
              ) : null}
              {enableAbAiMonetization() ? (
                <ArtworkQualityConfigPanelAbAiMonetization
                  className="scope-f5593a09"
                  index={index}
                  artwork={artwork}
                  reorderEnabled={reorderEnabled()}
                  activeConfigSection={activeConfigSection}
                  paidExpertEditAddonEnabled={paidExpertEditAddonEnabled()}
                  isMultiUpload={isMultiUpload}
                  onSetActiveConfigSection={handleSetActiveConfigSection}
                  data-testid="artwork-quality-config-panel-ab-ai-monetization"
                />
              ) : (
                <ArtworkQualityConfigPanel
                  className="scope-f5593a09"
                  index={index}
                  artwork={artwork}
                  activeConfigSection={activeConfigSection}
                  isMultiUpload={isMultiUpload}
                  onSetActiveConfigSection={handleSetActiveConfigSection}
                  data-testid="artwork-quality-config-panel"
                />
              )}
            </div>
          ) : null}
        </div>
        <div
          className={cn(
            "artwork__info scope-f5593a09",
            // @ts-expect-error TS migration
            showMultiSize() && "artwork__info--multi-size-presets"
          )}
        >
          {/* @ts-expect-error TS(2571): Object is of type 'unknown'. */}
          {isArtworkUploaded() && isSticker() && experiments().stickers_style_options ? (
            <StickersTabs
              className="artwork__tabs scope-f5593a09"
              tabs={TABS}
              artwork={artwork}
              slots={{
                default: ({ tab }: any) => (
                  <>
                    {}
                    {tab === "background" ? (
                      <StickersToolsBackground
                        className="artwork__section scope-f5593a09"
                        artwork={artwork}
                        data-testid="artwork-section"
                      />
                    ) : tab === "border" ? (
                      <StickersToolsBorder
                        className="artwork__section scope-f5593a09"
                        artwork={artwork}
                        data-testid="artwork-section-1"
                      />
                    ) : null}
                  </>
                )
              }}
              data-testid="artwork-tabs"
            />
          ) : null}
          <ArtworkInfo
            className="artwork__sizes artwork__sizes--desktop scope-f5593a09"
            artwork={artwork}
            isMultiUpload={isMultiUpload}
            index={index}
            data-testid="artwork-sizes-1"
          />

          {!withError() && warningMessage() ? (
            <ArtworkNotification className="scope-f5593a09" data-testid="artwork-notification">
              <b className="scope-f5593a09">{warningMessage()}</b>
            </ArtworkNotification>
          ) : null}
          {hasErrorMessage() ? (
            <ArtworkError
              className="scope-f5593a09"
              artwork={artwork}
              currentStore={currentStore}
              data-testid="artwork-error"
            />
          ) : null}
          {showRedrawNote() ? (
            <RedrawNotes
              ref={redrawNotesRef}
              index={index}
              enhancementNote={artwork.enhancementNote}
              isMultiUpload={isMultiUpload}
            />
          ) : null}
          {showReuploadBox() ? (
            <ReuploadBox className="scope-f5593a09" index={index} data-testid="reupload-box" />
          ) : (
            <div className="scope-f5593a09">
              {showMultiSize() ? (
                <>
                  <h3 className="artwork__multi-size-title scope-f5593a09">Set Design Size</h3>
                  <ArtworkMultiDimensions
                    className="scope-f5593a09"
                    artwork={artwork}
                    index={index}
                    disabled={artwork.isFile || disableCustomSizeInput()}
                    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
                    readonly={printAsIs() && !!metadata()}
                    isMultiUpload={isMultiUpload}
                    showFreeTransfersBadge={showFreeTransfersBadge}
                    data-testid="artwork-multi-dimensions"
                  />

                  <MultiSizeTotal
                    className="scope-f5593a09"
                    index={index}
                    isMultiUpload={isMultiUpload}
                    data-testid="multi-size-total"
                  />
                </>
              ) : (
                <>
                  <ArtworkDimensions
                    className="scope-f5593a09"
                    artwork={artwork}
                    index={index}
                    disabled={artwork.isFile || disableCustomSizeInput()}
                    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
                    readonly={printAsIs() && !!metadata()}
                    currentStore={currentStore}
                    isMultiUpload={isMultiUpload}
                    onOnChange={onDimensionsChange}
                    data-testid="artwork-dimensions"
                  />

                  <ArtworkQuantity
                    className="artwork__qty scope-f5593a09"
                    artwork={artwork}
                    index={index}
                    disabled={artwork.isFile}
                    readonly={printAsIs() && !!metadata()}
                    isMultiUpload={isMultiUpload}
                    onChange={onQtyChange}
                    data-testid="artwork-qty"
                  />
                </>
              )}
              {isArtworkUploaded() && !isStandardArtwork() ? (
                <TrimInfo
                  className="artwork__trim-info scope-f5593a09"
                  id={artwork.id}
                  artwork={artwork}
                  canRemoveBg={artwork.canRemoveBg}
                  removeBackground={artwork.removeBackground}
                  toggleBackgroundError={artwork.toggleBackgroundError}
                  reverse={true}
                  data-testid="artwork-trim-info"
                />
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
